import React from 'react';
import {View} from 'MWC';

class SearchInput extends View {
    constructor(props) {
        super(props);
    }

    render() {
        const {navigate, toggle, className} = this.props;

        return (
            <div
                className={`${
                    className ? className : 'module-header-mobile__menu__content__main__top__input'
                }`}
            >
                <input
                    type='text'
                    onClick={e => {
                        navigate('/search', e);
                        if (toggle) {
                            toggle();
                        }
                    }}
                    placeholder={this.l10n('NEW_HEADER_INPUT_PLACEHOLDER')}
                />
            </div>
        );
    }
}

export default SearchInput;
